module.exports = __webpack_public_path__ + "img/medal.378986f3.svg";